// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_SaveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_SaveInput — body for POST /franchisor-channels/save.
 *
 * `id` null = create; a positive int = update the existing channel.
 *
 * `api_key` is WRITE-ONLY and OPTIONAL: null or blank means "leave the
 * stored secret unchanged" on an update (the console never re-displays the
 * raw key, so it never has one to resend) — the controller resolves that
 * by reading the existing raw value via findRawForDelivery() before
 * writing. On CREATE, a blank key is stored as null (an unconfigured
 * channel; test_send on it fails closed with 'channel_not_configured').
 *
 * type/provider pairing is fixed at this phase's two starting providers
 * (docs/billing-franchisor-channels.md decision 2): email only pairs with
 * resend, sms only pairs with mobizon.
 */
import { registerContract } from './validate'

export interface FranchisorChannels_SaveInput {
name: string
type: string
provider: string
id?: number
api_key?: string
sender?: string
enabled?: boolean
}

registerContract('FranchisorChannels_SaveInput', {
  name:     { type: 'string',  required: true },
  type:     { type: 'string',  required: true },
  provider: { type: 'string',  required: true },
  id:       { type: 'number',  required: false },
  api_key:  { type: 'string',  required: false },
  sender:   { type: 'string',  required: false },
  enabled:  { type: 'boolean', required: false },
})
